export const resetAndAddClass = (selector, classNames) => {
  const elements = document.querySelectorAll(selector)

  if (!Array.isArray(classNames)) {
    classNames = [classNames]
  }

  if (elements.length > 0) {
    elements.forEach((element) => {
      if (element.classList.contains('cce-widget-faq-article')) return
      element.className = ''
      element.classList.add(...classNames)
    })
  }
}
